// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gd-0";
export var headerCellHover = "_gd-1";
export var readCellContainer = "_gd-2";
export var searchHighlight = "_gd-4";
export var unreadIndicator = "_gd-3";